import type { Block } from "@/types/proposals";

interface TermsBlockProps {
  block: Block;
  onUpdate: (updates: Partial<Block>) => void;
  onSelect: () => void;
}

export function TermsBlock({ block, onUpdate, onSelect }: TermsBlockProps) {
  const terms = block.content.terms || "Payment Terms:\n• 50% deposit required to schedule work\n• Balance due upon completion\n• Payment accepted: Cash, Check, Credit Card\n\nWarranty:\n• Manufacturer warranty on materials\n• Workmanship warranty provided\n\nScheduling:\n• Work begins within 2 weeks of deposit\n• Weather-dependent completion timeline\n\nThis proposal is valid for 30 days from the date issued.";

  return (
    <div
      className="cursor-pointer hover:ring-2 hover:ring-primary/50 transition-all rounded p-6 bg-muted/30"
      onClick={onSelect}
    >
      <h3 className="text-xl font-bold mb-4">Terms & Conditions</h3>
      <textarea
        value={terms}
        onChange={(e) => onUpdate({ content: { ...block.content, terms: e.target.value } })}
        className="w-full min-h-[200px] bg-transparent border-0 focus-visible:ring-0 text-sm whitespace-pre-wrap"
        placeholder="Enter terms and conditions..."
      />
    </div>
  );
}
